import get from 'lodash/get';

import { trimSearch } from '@xmatters/common/utils/searchUtil';
import { getUsersBySearchAction } from '../listPage';
import { getListingURIGenerator } from '../listPage/utils';

export const SEARCH_CONFERENCES_LIST_PAGE = 'SEARCH_CONFERENCES';
export const SEARCH_CONFERENCES_LIST_PAGE_SUCCESS = `${SEARCH_CONFERENCES_LIST_PAGE}_SUCCESS`;
export const SEARCH_CONFERENCES_LIST_PAGE_FAIL = `${SEARCH_CONFERENCES_LIST_PAGE}_FAIL`;
export const SEARCH_CONFERENCES_LIST_PAGE_START = `${SEARCH_CONFERENCES_LIST_PAGE}_START`;

export const SEARCH_URI = '/webapi/xm/1/conferences';

export const getSearchFilterParams = props => {
  const { startIndex = 0, stopIndex = 0, search, sortBy, sortOrder } = props;

  const status = get(props, 'status.value');
  const hosts = get(props, 'hosts.value');

  const sortOptions = {
    name: 'NAME',
    host: 'HOST',
    status: 'STATUS',
    startTime: 'START_TIME',
  };

  const params = {
    embed: 'events',
    include: 'activeParticipantCount',
    limit: 100,
    offset: 0,
  };

  if (sortBy && sortOrder) {
    params.sortBy = sortOptions[sortBy];
    params.sortOrder = sortOrder;
  }

  params.limit = Math.max(100, stopIndex - startIndex);
  params.offset = startIndex;

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
  }

  if (status && status.length) {
    params.status = status;
  }
  if (hosts && hosts.length) {
    params.hosts = hosts;
  }

  return params;
};

export const searchConferences = (props = {}) => {
  const params = getSearchFilterParams(props);

  return {
    type: SEARCH_CONFERENCES_LIST_PAGE,
    meta: {
      xmApi: true,
      method: 'get',
      uri: SEARCH_URI,
      params,
      customUriWithParamsGenerator: getListingURIGenerator,
    },
  };
};

export const CONFERENCES_LIST_PAGE_SET_LOADING =
  'CONFERENCES_LIST_PAGE_SET_LOADING';
export const setIsLoading = () => ({ type: CONFERENCES_LIST_PAGE_SET_LOADING });

export const CONFERENCES_LIST_PAGE_SEARCH_USERS =
  'CONFERENCES_LIST_PAGE_SEARCH_USERS';
export const CONFERENCES_LIST_PAGE_SEARCH_USERS_START = `${CONFERENCES_LIST_PAGE_SEARCH_USERS}_START`;
export const CONFERENCES_LIST_PAGE_SEARCH_USERS_SUCCESS = `${CONFERENCES_LIST_PAGE_SEARCH_USERS}_SUCCESS`;
export const CONFERENCES_LIST_PAGE_SEARCH_USERS_FAIL = `${CONFERENCES_LIST_PAGE_SEARCH_USERS}_FAIL`;
export const CONFERENCES_LIST_PAGE_RESET_USER_FILTERS =
  'CONFERENCES_LIST_PAGE_RESET_USERS_FILTERS';
export const CONFERENCES_LIST_PAGE_ACTIVE_USERS_FILTERS =
  'CONFERENCES_LIST_PAGE_ACTIVE_USERS_FILTERS';

export const getUsersBySearch = getUsersBySearchAction(
  CONFERENCES_LIST_PAGE_SEARCH_USERS,
);

export const setActiveUserFilters = users => ({
  type: CONFERENCES_LIST_PAGE_ACTIVE_USERS_FILTERS,
  payload: users,
});

export const resetUserFilters = users => ({
  type: CONFERENCES_LIST_PAGE_RESET_USER_FILTERS,
  payload: users,
});
